// @ts-nocheck
import React, { ReactComponentElement, ReactNode, useEffect, useRef, useState } from 'react';
import cs from 'classnames';
// import { ButtonProps, ButtonStatus, ButtonSize } from './button';
import { Colors } from '../../../lib';
import FontFamily from '../fontFamily';
import './index.scss';

export interface ButtonProps {
  /** 类型 */
  variant: 'Primary' | 'Secondary' | 'Text';
  size: ButtonSize;
  /** 文案 */
  title?: string;
  /** loading状态文案 */
  loadingTitle?: string;
  /** icon */
  icon?: ReactNode;
  /** 状态 */
  status?: ButtonStatus;
  /** 颜色 Primary类型中可修改底色，Secondary中修改边框颜色 */
  color?: string;
  /** 文案颜色 */
  titleColor?: string;
  /** 圆角 */
  borderRadius?: number;
  /** 最小宽度 */
  minWidth?: string;
  /** 最大高度 */
  maxWidth?: string;
  /** 主题 */
  mode?: 'White' | 'Dark';
  /** 可添加className */
  className?: string;
  /** 点击事件 */
  onClick?: () => void;
}

export enum ButtonStatus {
  default = 'Default',
  disabled = 'Disabled',
  loading = 'Loading'
}

export enum ButtonSize {
  large = 'Large',
  medium = 'Medium',
  small = 'Small'
}

// eslint-disable-next-line max-lines-per-function
export const Button = (props: ButtonProps): ReactComponentElement<any> => {
  const prefixClassname = 'design-system-button';
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const {
    variant,
    size = ButtonSize.large,
    status = ButtonStatus.default,
    title = '',
    icon,
    color = '',
    borderRadius = 4,
    titleColor,
    mode = 'White',
    /** 业务classname */
    className = '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick = (event: any): void => {},
  } = props;
  const { loadingTitle = title } = props;
  const { maxWidth, minWidth } = props;
  const elementRef = useRef<HTMLDivElement>(null);
  const fakeElementRef15 = useRef<HTMLDivElement>(null);
  const fakeElementRef13 = useRef<HTMLDivElement>(null);
  /** 用来控制字号缩放变化 */
  const [smallFont, setSmallFont] = useState(15);
  const [isPressed, setPressed] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);

  useEffect(() => {
    const eleMaxWidth =
      size === ButtonSize.large && variant !== 'Text' ?
        screen.width - 32 :
        Number(window.getComputedStyle(elementRef.current as Element, null).maxWidth.replace(/px|rem/g, ''));
    // 设置字号
    if (elementRef.current && fakeElementRef13.current && fakeElementRef15.current) {
      if (
        elementRef.current.clientWidth < fakeElementRef13.current.clientWidth ||
        (elementRef.current.clientWidth >= fakeElementRef13.current.clientWidth &&
          elementRef.current.clientWidth < fakeElementRef15.current.clientWidth &&
          window.innerWidth - 32 < elementRef.current.clientWidth)
      ) {
        setSmallFont(11);
      } else if (
        (elementRef.current.clientWidth < fakeElementRef15.current.clientWidth &&
          elementRef.current.clientWidth >= fakeElementRef13.current.clientWidth) ||
        (elementRef.current.clientWidth === fakeElementRef15.current.clientWidth &&
          window.innerWidth - 32 < elementRef.current.clientWidth)
      ) {
        setSmallFont(13);
      }
      if (fakeElementRef13.current.clientWidth < eleMaxWidth) {
        setSmallFont(13);
      }
      if (fakeElementRef15.current.clientWidth < eleMaxWidth) {
        setSmallFont(15);
      }
    }
    setTitleVisible(true);
  }, [title, loadingTitle, smallFont, size, titleVisible]);

  useEffect(() => {
    // eslint-disable-next-line max-len
    let commonStyle = '';
    if (variant === 'Primary') {
      commonStyle += `background-color: ${color}; `;
    } else if (variant === 'Secondary') {
      commonStyle += `border-color: ${color}; `;
    }
    commonStyle += `border-radius:${borderRadius}; min-width: ${minWidth}; max-width: ${maxWidth}`;
    // 设置最大宽度 32是左右边距和
    if (titleVisible) {
      if (elementRef.current && screen.width - 32 <= elementRef.current.clientWidth) {
        elementRef.current.setAttribute('style', `${commonStyle} max-width: ${screen.width - 32}px; margin: 0 auto`);
      } else {
        elementRef.current?.setAttribute('style', commonStyle);
      }
      if (loadingTitle.length < title.length) {
        const width = elementRef.current?.clientWidth;
        elementRef.current?.setAttribute('style', `width: ${width}px`);
      }
      setButtonVisible(true);
    }
  }, [titleVisible, color, minWidth, maxWidth, variant]);

  const handleClick = (event: any): void => {
    if (status !== ButtonStatus.default) {
      return;
    }
    onClick(event);
  };

  const handleTouchStart = (): void => {
    setPressed(true);
  };

  const handleTouchEnd = (): void => {
    setPressed(false);
  };

  return (
    <FontFamily className={className}>
      <div className={prefixClassname}>
        <div
          className={cs(
            `${prefixClassname}-container`,
            `${prefixClassname}-${variant}`,
            `${prefixClassname}-${size}`,
            `${prefixClassname}-${status}`,
            {
              [`${prefixClassname}-font-13`]: smallFont === 13 && titleVisible,
              [`${prefixClassname}-font-11`]: smallFont === 11 && titleVisible,
              [`${prefixClassname}-Pressed`]: isPressed,
              [`${prefixClassname}-icon-button`]: icon && !title,
              [`${prefixClassname}-hidden`]: !buttonVisible,
              dark: mode === 'Dark',
            }
          )}
          ref={elementRef}
          onClick={handleClick}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          onTouchCancel={handleTouchEnd}
        >
          {status === ButtonStatus.loading && (
            <div
              className={cs(`${prefixClassname}-loading-icon ${prefixClassname}-button-icon`, {
                [`${prefixClassname}-text-loading`]: !icon && title,
                [`${prefixClassname}-only-icon`]: icon && !title,
              })}
            />
          )}
          {icon && status !== ButtonStatus.loading && (
            <div
              className={cs(`${prefixClassname}-button-icon`, {
                [`${prefixClassname}-only-icon`]: icon && !title,
              })}
            >
              {icon}
            </div>
          )}
          <div
            className={cs(`${prefixClassname}-button-text`, {
              [`${prefixClassname}-text-loading`]: status === ButtonStatus.loading && !icon,
            })}
            style={{ color: titleColor || (mode === 'Dark' ? Colors.N00_90 : Colors.N100_90) }}
          >
            {status === ButtonStatus.loading && buttonVisible ? loadingTitle : title}
          </div>
        </div>
        {/* 用来适配文字大小变化 */}
        <div
          style={{ minWidth: `${minWidth}`, maxWidth: `${maxWidth}` }}
          className={cs(
            `${prefixClassname}-container ${prefixClassname}-fake`,
            className,
            `${prefixClassname}-${variant}`,
            `${prefixClassname}-${size}`,
            `${prefixClassname}-${status}`,
            {
              [`${prefixClassname}-icon-button`]: icon && !title,
            }
          )}
          ref={fakeElementRef15}
        >
          {icon && <div className={cs(`${prefixClassname}-button-icon`)}>{icon}</div>}
          <div className={`${prefixClassname}-button-text`}>{title}</div>
        </div>
        <div
          style={{ minWidth: `${minWidth}`, maxWidth: `${maxWidth}` }}
          className={cs(
            `${prefixClassname}-container ${prefixClassname}-fake ${prefixClassname}-font-13`,
            className,
            `${prefixClassname}-${variant}`,
            `${prefixClassname}-${size}`,
            `${prefixClassname}-${status}`,
            {
              [`${prefixClassname}-icon-button`]: icon && !title,
            }
          )}
          ref={fakeElementRef13}
        >
          {icon && <div className={cs(`${prefixClassname}-button-icon`)}>{icon}</div>}
          <div className={`${prefixClassname}-button-text`}>{title}</div>
        </div>
      </div>
    </FontFamily>
  );
};
